import { useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useQuery } from 'react-query';

const useAllPendingUpdates = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchAllPendingUpdates = async () => {
    if (!vesselId) {
      throw new Error('Vessel ID is required to fetch pending updates.');
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/pendingUpdates/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        throw new Error('Failed to fetch all pending updates.');
      }

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'An error occurred while fetching all pending updates.');
    }
  };

  return useQuery(['allPendingUpdates', vesselId], fetchAllPendingUpdates, {
    enabled: !!vesselId, // Only run query if vesselId is provided
  });
};

export default useAllPendingUpdates;
